import Flex from 'UIKit/Box/Flex'
import Grid from 'UIKit/Box/Grid'
import { FlexProps } from 'UIKit/Box/types'
import EmptyContent from 'UIKit/EmptyContent'
import HunnyList from 'UIKit/HunnyList'
import useMatchBreakpoints from 'hooks/useMatchBreakpoints'
import React from 'react'
import { useTranslation } from 'react-i18next'
import { BaseResponse, HunnyRequest, Paging } from 'services/types'
import { useNavigationInfo } from 'state/app/hooks'
import styled from 'styled-components'
import { breakpointMap } from 'theme/base'
import { buildResponsiveStyledSystemWithExceptedComponent } from 'utils/styled'
import GameItem from './GameItem'
import GameItemLoader from './GameItemLoader'

const StyledGrid = styled(Grid)`
  padding: 0px;
  width: 100%;

  ${({ theme }) => theme.mediaQueries.sm} {
    background: ${({ theme }) => theme.colors.backgroundAlt};
    padding: 12px;
    border-radius: 26px;
  }

  ${({ theme }) => theme.mediaQueries.lg} {
    border-radius: 28px;
  }

  ${({ theme }) => theme.mediaQueries.xxl} {
    border-radius: 32px;
  }
`
const LazyGameItem = ({ item }) => (
  <GameItem p={['6px !important', '', '', '', '8px !important', '', '12px !important']} game={item} />
)

type GameListProps = {
  request: (offset: number, limit: number) => HunnyRequest<BaseResponse<Paging<any>>>
  noContent?: React.ReactNode
}

const GameList: React.FC<GameListProps & FlexProps> = ({ request, noContent, ...props }) => {
  const { isXl, isXxl } = useMatchBreakpoints()
  const { t } = useTranslation()

  const { sidebarWidth } = useNavigationInfo()

  return (
    <Flex flexDirection="column" {...props}>
      <StyledGrid
        gridTemplateColumns={buildResponsiveStyledSystemWithExceptedComponent(
          [
            '1fr 1fr',
            '1fr 1fr',
            '1fr 1fr 1fr',
            '1fr 1fr 1fr 1fr',
            '1fr 1fr 1fr 1fr',
            '1fr 1fr 1fr 1fr 1fr',
            '1fr 1fr 1fr 1fr 1fr',
          ],
          sidebarWidth,
          breakpointMap.sm,
        )}
        className="hunny-lazy-list"
      >
        <HunnyList
          processContent="You've viewed {{count}} of {{total}} games"
          uniqueKey="code"
          Item={LazyGameItem}
          noContent={
            noContent || (
              <EmptyContent
                flex={1}
                width="100%"
                justifyContent="center"
                height="100%"
                alignItems="center"
                content={t('No game found.')}
              />
            )
          }
          Loader={
            <>
              <GameItemLoader />
              <GameItemLoader />
              <GameItemLoader />
              <GameItemLoader />
              <GameItemLoader />
              <GameItemLoader />
              <GameItemLoader />
              <GameItemLoader />
              <GameItemLoader />
              <GameItemLoader />
            </>
          }
          request={request}
          limit={isXl || isXxl ? 20 : 30}
        />
      </StyledGrid>
    </Flex>
  )
}

export default GameList
